import { render, staticRenderFns } from "./StockMovementViewDetailsProductList.vue?vue&type=template&id=2fbdbe08&"
import script from "./StockMovementViewDetailsProductList.vue?vue&type=script&lang=js&"
export * from "./StockMovementViewDetailsProductList.vue?vue&type=script&lang=js&"
import style0 from "./StockMovementViewDetailsProductList.vue?vue&type=style&index=0&id=2fbdbe08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports